import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import DashboardPage from "../pages/DashboardPage";

export default () => {
    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <DashboardPage/>
                </Route>
            </Switch>
        </Router>
    );
};